// extracted by mini-css-extract-plugin
export default {"list-item":"delivery-types_list-item__BkO7M","actions-buttons":"delivery-types_actions-buttons__ZnWIV"};